import { render } from "./Calendar.vue?vue&type=template&id=46155f52&scoped=true&ts=true"
import script from "./Calendar.vue?vue&type=script&lang=ts"
export * from "./Calendar.vue?vue&type=script&lang=ts"

import "./Calendar.vue?vue&type=style&index=0&id=46155f52&lang=less&scoped=true"

import exportComponent from "D:\\work\\project\\mobile-mpe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46155f52"]])

export default __exports__